import { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterThree from "../components/FooterThree";
import HeaderOne from "../components/HeaderOne";
import { useLoader } from "../context/LoaderContext";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";
import { fetchCompanyDetails } from "../api/CompanyDetailsApi";
import { useAllDataContext } from "../context/AllDataContext";
import { FetchAllApi } from "../components/FetchAllApi";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

const CoreValuesPage = () => {
  const { allData, setAllData } = useAllDataContext();
  const { companyDetailsData, setCompanyDetailsData } =
    useCompanyDetailsContext();
  const { setLoading } = useLoader();

  FetchAllApi({ companyDetailsData, setAllData, setLoading });
  const coreValuesBannerData = allData.allBannerData[0]?.our_core_values_title;

  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([companyDetailsData]) => {
          setCompanyDetailsData(companyDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);

  return (
    <>
      <Preloader />

      <Animation />

      <HeaderOne />

      <Breadcrumb
        heading={coreValuesBannerData}
        title={"Academic"}
        subTitle={"Our Core Values"}
      />

      <img
        src={`${process.env.REACT_APP_cmsUrl}${allData.coreValuesData[0]?.image[0]?.media?.url}`}
        alt="Our Core Values"
      />

      <FooterThree />
    </>
  );
};

export default CoreValuesPage;
